const config = {
    baseAppUrl: {
        $default: 'https://localhost:3000',
        staging: 'https://dev-app.spyetsy.com',
        production: 'https://app.spyetsy.com',
    },
    baseUrl: {
        $default: 'http://localhost:3001',
        staging: 'https://dev-admin.spyetsy.com',
        production: 'https://admin.spyetsy.com',
    },
    baseAPI: {
        $default: 'https://dev.spyetsy.com',
        staging: 'https://dev.spyetsy.com',
        production: 'https://prod.spyetsy.com',
    },
    baseAdminAPI: {
        $default: 'https://dev.spyetsy.com/admin',
        staging: 'https://dev.spyetsy.com/admin',
        production: 'https://prod.spyetsy.com/admin',
    },
    baseAdminAffiliate: {
        $default: 'https://dev.spyetsy.com/affiliate',
        staging: 'https://dev.spyetsy.com/affiliate',
        production: 'https://prod.spyetsy.com/affiliate'
    },
    basePaymentAPI:{
        $default: 'https://dev.spyetsy.com/payment',
        staging: 'https://dev.spyetsy.com/payment',
        production: 'https://prod.spyetsy.com/payment'
    }
};

const _getEnvironment = () => {
    return process.env.REACT_APP_ENV || 'development';
};

export default (key, defaultValue = null) => {
    if (!config.hasOwnProperty(key)) {
        return defaultValue;
    }

    const env = _getEnvironment();
    const _dataConfig = config[key];

    return _dataConfig[env] ? _dataConfig[env] : _dataConfig['$default'] || defaultValue;
};


// WEBPACK FOOTER //
// ./src/helpers/common/getEnv.js